import React, { useEffect } from 'react';
import './Toast.css';

export type ToastType = 'success' | 'error' | 'info';

export interface ToastMsg {
  id:      number;
  type:    ToastType;
  message: string;
}

interface Props {
  toasts:   ToastMsg[];
  onRemove: (id: number) => void;
}

const ICONS: Record<ToastType, string> = { success: '✅', error: '❌', info: 'ℹ️' };

const Toast: React.FC<Props> = ({ toasts, onRemove }) => {
  useEffect(() => {
    if (toasts.length === 0) return;
    const t = setTimeout(() => onRemove(toasts[0].id), 3500);
    return () => clearTimeout(t);
  }, [toasts, onRemove]);

  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast-${t.type}`} onClick={() => onRemove(t.id)}>
          <span>{ICONS[t.type]}</span>
          <span>{t.message}</span>
        </div>
      ))}
    </div>
  );
};

export default Toast;

// Hook for easy toast management
export const useToast = () => {
  const [toasts, setToasts] = React.useState<ToastMsg[]>([]);
  const push = (message: string, type: ToastType = 'success') =>
    setToasts(prev => [...prev, { id: Date.now(), type, message }]);
  const remove = (id: number) => setToasts(prev => prev.filter(t => t.id !== id));
  return { toasts, push, remove };
};
